module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.54a91b0.ttf";